module.exports = __webpack_public_path__ + "static/fieldingenvironmental-logo-3af7b93ee162334131dc6d31adf44507.png";